module.exports = __webpack_public_path__ + "static/notebook-9ea27a835b251a5b06905f26316ee68e.png";